<template>
  <div id="attendance-page3">
    <div>
      <RadioTop :options="areas" :defaultValue="area" @input="area=$event" :style="{marginTop: '60px'}"/>
    </div>
    <div>
      <div id="div1">
        <button @click="start=moment(start).add(-1, 'month').format('yyyy-MM-DD');date=start"><svg width="11" height="25" viewBox="0 0 11 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill="var(--color-checked)" d="M10.9999 1.32828C10.9999 1.59793 10.9169 1.872 10.7419 2.10629L3.78757 11.5264C3.35685 12.1077 3.35685 12.8923 3.78757 13.4736L10.7419 22.8937C11.1793 23.4861 11.047 24.3149 10.4458 24.7459C9.84456 25.1769 9.00331 25.0465 8.56586 24.4541L1.61154 15.0341C0.492117 13.5178 0.492117 11.4822 1.61154 9.96595L8.56586 0.545849C9.00331 -0.0464977 9.84456 -0.176903 10.4458 0.254097C10.8069 0.512695 10.9999 0.917171 10.9999 1.32828Z"/>
        </svg>
        </button>
        <div>{{moment(start).year()}} , {{moment(start).format('M月')}} </div>
        <button @click="start=moment(start).add(1, 'month').format('yyyy-MM-DD');date=start"><svg width="11" height="25" viewBox="0 0 11 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill="var(--color-checked)" d="M4.68732e-06 23.6717C4.69911e-06 23.4021 0.0830087 23.128 0.257988 22.8937L7.21231 13.4736C7.64303 12.8923 7.64303 12.1077 7.21231 11.5264L0.257989 2.10629C-0.179461 1.51394 -0.0471039 0.685096 0.554109 0.254097C1.15532 -0.176902 1.99657 -0.046497 2.43402 0.545851L9.38834 9.96595C10.5078 11.4822 10.5078 13.5178 9.38834 15.0341L2.43402 24.4542C1.99657 25.0465 1.15532 25.1769 0.554108 24.7459C0.192931 24.4873 4.66935e-06 24.0828 4.68732e-06 23.6717Z"/>
        </svg>
        </button>
        <!-- <Btn :text="'自訂時間'" :bg="'var(--color-checked)'" class="settimebtn" @click="calc=true"/> -->
      </div>
      <div class="celendar" :style="{marginTop: '21px'}">
        <div v-for="i in 7" :key="`wdy-${i}`" class="wdy">週{{wdy[i-1]}}</div>
        <div class="day pass" v-for="i in startWdy" :key="`pass-${i}`"></div>
        <div class="day" v-for="i in duration" :key="`day-${i}`" @click="date=moment(start).add(i - 1, 'day').format('yyyy-MM-DD')"
        :class="date===moment(start).add(i - 1, 'day').format('yyyy-MM-DD')?'selected':''">
          <div>{{i}}</div>
          <div v-if="areasdata&&areasdata[moment(start).add(i - 1, 'day').format('yyyy-MM-DD')]">
            <div v-for="(staff, s) in areasdata[moment(start).add(i - 1, 'day').format('yyyy-MM-DD')].staffs" :key="`staff-${s}`" class="staff">
            {{staff.name}}</div>

            <div v-for="(staff, s) in areasdata[moment(start).add(i - 1, 'day').format('yyyy-MM-DD')].pts" :key="`staff-${s}`" class="staff pt">
            {{staff.name}}</div>
          </div>
          </div>
        <div class="day future" v-for="i in endWdy" :key="`future-${i}`"></div>
      </div>
    </div>
  </div>
</template>

<script>
import RadioTop from '../../components/radio/r1_v.vue'
import { getapi } from '../../store/fetch'
export default {
  components: {
    RadioTop
  },
  data () {
    return {
      area: null,
      wdy: ['一', '二', '三', '四', '五', '六', '日'],
      start: this.moment().startOf('month').format('yyyy-MM-DD'),
      areas: [],
      areasdata: null,
      date: this.moment().startOf('month').format('yyyy-MM-DD')
    }
  },
  async mounted () {
    this.areas = await getapi('selections/cmcp_areas')
    this.area = this.areas[0]
    await this.getdata()
  },
  computed: {
    startWdy () {
      return (this.moment(this.start).weekday() + 6) % 7
    },
    endWdy () {
      return 7 - ((this.moment(this.start).endOf('month').weekday() + 6) % 7 + 1)
    },
    duration () {
      return this.moment(this.start).endOf('month').diff(this.moment(this.start), 'day') + 1
    }
  },
  watch: {
    start () { this.getdata() },
    area () { this.getdata() }
  },
  methods: {
    async getdata () {
      console.log('getdata -------------- ')
      this.areasdata = await getapi(`cmcpAttendance/range/${this.area}?${new URLSearchParams({
        start: this.moment(this.start).startOf('day').toISOString(),
        duration: this.duration
      })}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.staff {
  margin-inline: auto;
  margin-bottom: 10px;
  height: 35px;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  width: 130px;
  background-color: var(--color-infobox);
  letter-spacing: .1em;
  &.pt {
    background-color: rgba(255, 228, 228, 0.9);
  }

}
.celendar {
  max-height: calc(100vh - 195px);
  padding-inline: 5px;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  border-radius: 5px;
  overflow: auto;
  box-sizing: border-box;
  &>div{
    flex:1;
  }
  .wdy {
    background-color: var(--color-checked);
    color: #FFFFFF;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: 24px;
    line-height: 27px;
    text-align: center;
    letter-spacing: 0.1em;
    &:nth-child(1) {
      border-radius: 5px 0 0 0;
    }
    &:nth-child(7) {
      border-radius:  0 5px 0 0;
    }
  }
  .day {
    min-height: 100px;
    min-height: 147px;
    border-right: 1px solid #DADADA;
    border-bottom: 1px solid #DADADA;
    &:nth-of-type(7n-6) {
      border-left: 1px solid #DADADA;
    }
    &>div:nth-child(1) {
      font-weight: 500;
      font-size: 18px;
      line-height: 27px;
      text-align: center;
      letter-spacing: 0.1em;
      color: var(--color-checked);
      padding-block: 10px;
    }
    &.selected {
      background-color: var(--color-infobox);
    }
  }
}
#div1{
  position: relative;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 40px;
  padding-inline: 5px;
  &>div{
    min-width: 290px;
    font-weight: 500;
    font-size: 24px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.1em;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color-checked);
  }
  button {
    background-color: transparent;
  }
}
#attendance-page3 {
  display: grid;
  flex: 1;
  max-height: calc(100vh - 90px);
  grid-template-rows: 100%;
  grid-template-columns: 310px 1fr;
  &>div{
    flex: 1;
    padding-block: 20px;
    padding-inline: 20px;
    overflow-y: auto;
    height: -webkit-fill-available;
  }
  padding-inline: 47px 22px;
}
</style>
